module.exports = __webpack_public_path__ + "img/yml_gallery7.c55a7d01.jpg";